import ScrollReveal from './ScrollReveal';

const learnings = [
  {
    icon: 'ri-user-search-line',
    title: 'Cliente Ideal',
    desc: 'Aprende a investigar y comprender a tu cliente ideal.',
  },
  {
    icon: 'ri-robot-2-line',
    title: 'Inteligencia Artificial',
    desc: 'Utiliza IA para acelerar todo el proceso creativo.',
  },
  {
    icon: 'ri-advertisement-line',
    title: 'Creación de Anuncios',
    desc: 'Diseña anuncios que captan atención y convierten.',
  },
  {
    icon: 'ri-focus-3-line',
    title: 'Tipos de Campaña',
    desc: 'Aprende cuándo utilizar cada objetivo de Meta Ads.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Configuración Profesional',
    desc: 'Construye campañas correctamente desde cero.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Optimización',
    desc: 'Analiza métricas para mejorar constantemente.',
  },
];

export default function WhatYouLearn() {
  return (
    <section className="py-20 md:py-28 bg-[#F7F8FA]">
      <div className="mx-auto max-w-[1280px] px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-14">
            <span className="inline-block text-xs font-semibold tracking-wider uppercase text-[#C8A24A] mb-3">
              Aprendizaje
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-[#111111]">
              ¿Qué aprenderás?
            </h2>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {learnings.map((item, idx) => (
            <ScrollReveal key={item.title} delay={idx * 80}>
              <div className="group bg-white rounded-2xl p-6 md:p-7 border border-gray-100 hover:border-[#E53935]/20 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(0,0,0,0.06)] cursor-default">
                <div className="w-12 h-12 rounded-xl bg-[#E53935]/5 flex items-center justify-center mb-5 group-hover:bg-[#E53935]/10 transition-colors duration-300">
                  <i className={`${item.icon} text-[#E53935] text-xl`}></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-[#111111] mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-[#666666] leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}